import { N8N_AVAILABILITY_URL } from "../constants";

/**
 * Fetches reserved quantities per toy for a given reservation date from n8n webhook.
 * The API returns an array of { id, quantite } where quantite = quantité réservée (indisponible).
 * Duplicate ids are summed.
 * Combine with getToys (disponible + extra) to get real available: maxStock - reserved.
 * @param {Date|string} date - Reservation date (Date object or YYYY-MM-DD string)
 * @returns {Promise<Record<string, number>>} Map of toy id -> reserved quantity (quantité réservée)
 */
function toLocalDateString(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export async function getToysAvailability(date) {
  const dateStr =
    date instanceof Date
      ? toLocalDateString(date)
      : typeof date === "string"
        ? date.slice(0, 10)
        : null;
  if (!dateStr) {
    return {};
  }

  try {
    const response = await fetch(N8N_AVAILABILITY_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ date: dateStr }),
    });

    if (!response.ok) {
      return {};
    }

    const json = await response.json();
    const data = json.data ?? json;
    const list = Array.isArray(data) ? data : Object.entries(data).map(([id, qty]) => ({ id, quantite: qty }));

    return list.reduce((acc, item) => {
      const id = item.id;
      const reserved = Number(item.quantite ?? item.quantity ?? 0);
      acc[id] = (acc[id] ?? 0) + Math.max(0, reserved);
      return acc;
    }, {});
  } catch {
    return {};
  }
}
